/** Live checklist that turns each rule green as the typed password
 *  satisfies it. Mirrors backend validate_password_complexity exactly. */
import { Check, X } from "lucide-react";

const RULES = [
  { id: "len", label: "At least 10 characters", test: (p) => p.length >= 10 },
  { id: "lower", label: "One lowercase letter", test: (p) => /[a-z]/.test(p) },
  { id: "upper", label: "One uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { id: "digit", label: "One number", test: (p) => /\d/.test(p) },
  { id: "symbol", label: "One symbol (e.g. ! ? # $)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

/** Returns true iff the typed password satisfies the backend rules:
 *  - length >= 10
 *  - 3 of 4 character classes (lowercase, uppercase, digit, symbol)
 *  Used by parent forms for client-side enable/disable. */
export function isPasswordStrong(p) {
  if (!p || p.length < 10) return false;
  const classes = ["lower", "upper", "digit", "symbol"]
    .filter((id) => RULES.find((r) => r.id === id).test(p)).length;
  return classes >= 3;
}

export default function PasswordRequirements({ value = "" }) {
  return (
    <ul className="mt-1.5 space-y-1 text-xs text-neutral-600" data-testid="password-requirements">
      {RULES.map((r) => {
        const ok = r.test(value);
        return (
          <li key={r.id} className={`flex items-center gap-1.5 ${ok ? "text-emerald-700" : ""}`}>
            {ok ? <Check className="w-3 h-3 shrink-0" /> : <X className="w-3 h-3 shrink-0 text-neutral-300" />}
            {r.label}
          </li>
        );
      })}
      <li className="text-neutral-500 pt-1">Need at least 3 of the 4 character types.</li>
    </ul>
  );
}
